import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTimeSeriesData } from '../../../api/timeseriesApi';
import { selectManyTimeSeriesData } from '../../../store/slices/timeseries.slice';



const usePortfolioTimeseries = (symbols, startDate) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const timeSeriesData = useSelector(state => selectManyTimeSeriesData(state, symbols));

    const fetchTimeSeries = useCallback(async () => {
        if (!symbols.length) return;
        try {
            setLoading(true);
            await dispatch(fetchTimeSeriesData({ symbols, startDate }));
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch time series data');
            setLoading(false);
        }
    }, [dispatch, symbols, startDate]);

    useEffect(() => {
        fetchTimeSeries();
    }, [fetchTimeSeries]);

    return { timeSeriesData, loading, error };
};

export default usePortfolioTimeseries;
